<template>
  <div class="container">
    <div class="subscription-container">
      <div
        class="temporary_show-container"
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        v-if="SubscriptionData.length === 0"
      >
        暂无数据
      </div>
      <div class="subscription-list">
        <div
          class="item"
          v-for="(item, index) in SubscriptionData"
          :key="item.id"
        >
          <router-link
            :to="{ name: 'my_subscription_details', params: { id: item.id } }"
          >
            <img class="item-image" :src="item.image.file_src" />
            <p class="item-title">{{ item.name }}</p>
            <div class="item_content">
              <p class="item_content-text">
                {{ item.content }}
              </p>
            </div>
          </router-link>
          <div class="item-button">
            <el-button
              class="download-button"
              plain
              size="mini"
              @click="downloadData(item.file, item.id)"
              >下载</el-button
            >
            <el-button
              class="cancel-button"
              plain
              size="mini"
              type="danger"
              @click="handleCancleSub(item.id, index)"
            >
              取消订阅
            </el-button>
          </div>
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="currentPage"
        :page-count="pageCount"
        @current-change="editCurrentPage"
        :hide-on-single-page="true"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import userService from "@/global/service/user";
import classService from "@/global/service/class";
export default {
  data() {
    return {
      SubscriptionData: [],
      pageSize: 10,
      pageCount: null,
      total: null,
      currentPage: 1,
      loading: true
    };
  },
  created() {
    this.getData();
  },
  methods: {
    handleCancleSub(id, index) {
      this.$confirm("确认取消订阅该课件？").then(() => {
        classService.coursewareIdCancelSub(id).then(() => {
          this.$message.success("取消订阅成功");
          this.SubscriptionData.splice(index, 1);
        });
      });
    },
    downloadData(file, id) {
      classService.coursewareDownload(id).then(() => {
        const el = document.createElement("a");
        document.body.appendChild(el);
        el.href = file.file_src;
        el.download = file.file_name;
        el.target = "_blank";
        el.click();
        document.body.removeChild(el);
      });
    },
    editCurrentPage(index) {
      this.currentPage = index;
      this.getData();
    },
    getData() {
      const params = {
        page: this.currentPage,
        page_size: this.pageSize
      };
      userService
        .coursewareSubList(params)
        .then(res => {
          this.SubscriptionData = res.list;
          this.currentPage = res.pagination.current_page;
          this.total = res.pagination.total;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.subscription-container {
  .subscription-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 30px;
    .item {
      margin: 6px 6px 20px;
      width: 48%;
      background-color: #fff;
      .item-image {
        width: 100%;
        height: calc(100vh / 3);
      }
      .item-title {
        font-size: 16px;
        font-weight: 600;
        line-height: 30px;
        padding: 10px;
        text-align: left;
        border-bottom: 1px solid #ff9900;
      }
      .item_content {
        padding: 5px 10px;
        overflow: hidden;
        .item_content-text {
          font-size: 12px;
          line-height: 20px;
          color: #999;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
      .item-button {
        padding: 5px 10px;
        text-align: left;
      }
      .download-button {
        color: #fff;
        background: #ff9900;
        border-color: #ff9900;
        transition: all 0.2s;
        &:hover {
          opacity: 0.7;
        }
      }
      .cancel-button {
      }
    }
  }
}
</style>
